// extracted by mini-css-extract-plugin
export default {"form":"Input_form__gc8iD","input":"Input_input__o3RDV"};